var React = require('react');

function NextInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Arrow"),React.createElement("g",{"id":"Y2_Students","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Desktop-HD","transform":"translate(-391.000000, -16.000000)","fill":"#000000"},React.createElement("g",{"id":"PREV/NEXT","transform":"translate(298.000000, 15.000000)"},React.createElement("g",{"id":"Arrow","transform":"translate(93.000000, 1.000000)"},React.createElement("polygon",{"id":"Page-1","points":"17.3268148 0 17.3268148 1.48 25.3182222 9.492 0 9.492 0 10.514 25.312 10.514 17.3268148 18.518 17.3268148 20 27.2958519 10"})))))]);
}

NextInline.defaultProps = {"width":"28px","height":"20px","viewBox":"0 0 28 20","version":"1.1"};

module.exports = NextInline;

NextInline.default = NextInline;
